import { render, staticRenderFns } from "./cargo.vue?vue&type=template&id=10921807&scoped=true"
import script from "./cargo.vue?vue&type=script&lang=js"
export * from "./cargo.vue?vue&type=script&lang=js"
import style0 from "./cargo.vue?vue&type=style&index=0&id=10921807&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10921807",
  null
  
)

export default component.exports